<template>
  <div class="btns">
    <template v-for="item in button">
      <el-upload
          v-if="item.key === 'importFormConfig'"
          :key="item.key"
          class="upload-form-config"
          style="display: inline-block; margin-left: 10px"
          accept=".zip"
          :action="`${baseUrl}/formConfig/import`"
          :headers="{
            'Authorization': token
          }"
          :on-progress="handleLoading"
          :on-success="handleLoadingClose"
          multiple
          :limit="3">
        <el-button :loading="loading"
                   :style="{ fontSize: fonts, fontFamily: family, fontWeight: weight }"
                   :size="size" type="primary">{{ item.label }}</el-button>
      </el-upload>
      <el-button
        v-else
        :loading="loading"
        :size="size"
        type="primary"
        :icon="item.icon"
        :style="{ fontSize: fonts, fontFamily: family, fontWeight: weight }"
        :key="item.key"
        :disabled="item.disabled"
        @click="handleClickButton(item.key, item.label)"
      >{{ item.label }}</el-button>
    </template>
  </div>
</template>
<script>
import { checkFont, getSession } from "@/utils/methods";
import Vue from "vue";
export default {
  name: "Y-button",
  props: {
    button: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: "mini",
    },
  },
  data() {
    return {
      loading: false,
      fonts: null,
      family: '',
      weight: '',
      baseUrl: Vue.prototype.$baseUrl,
      token: getSession('vue_admin_template_token'),
      uploadLoading: null
    };
  },
  methods: {
    handleLoading() {
      this.uploadLoading = this.$loading({ fullscreen: true, lock: true })
    },
    handleLoadingClose() {
      this.uploadLoading.close()
      this.$message.success(this.$t('addTips.done'))
      this.$emit("handleClickButton", 'importFormConfig');
    },
    handleClickButton(val, label) {
      if (!val) return;
      this.$emit("handleClickButton", val, label);
    },
    isLoading(loading = false) {
      this.loading = loading
    }

  },
  mounted() {
    let font = checkFont(), info = getSession('users');
    this.fonts = font;
    this.family = info?.fontFamily == '默认' ? "Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif" : info.fontFamily;
    this.weight = info.fontWeight == 'bold' ? 'bold' : 'normal';
  }
};
</script>

<style scoped lang="scss">
.btns {
  display: flex;
  align-items: flex-start;
  // margin-bottom: 10px;
}

/deep/.upload-form-config > .el-upload-list {
  display: none;
}
</style>
